export enum SelfSellInCatalogDownloadType {
  SEASON = 'season-catalog',
  OVERVIEW = 'commercial-overview',
}
